import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
/* empty css          */
const KeycapHint = (t0) => {
  const $ = c(5);
  const {
    keys,
    ariaLabel
  } = t0;
  let t1;
  if ($[0] !== keys) {
    t1 = keys.map(_temp);
    $[0] = keys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ariaLabel || $[3] !== t1) {
    t2 = /* @__PURE__ */ jsx("span", { className: "graphiql-keycap-hint", "aria-label": ariaLabel, children: t1 });
    $[2] = ariaLabel;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(k, i) {
  return /* @__PURE__ */ jsx("kbd", { className: "graphiql-keycap", children: k }, `${k}-${i}`);
}
export {
  KeycapHint
};
//# sourceMappingURL=index.js.map
